// @ts-nocheck
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskPisPasep {
  public insertIconValidate = true;

  public maxLength = 11;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);

    if (newValue.length > this.maxLength) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }

    return { newValue, newCursorPosition };
  }

  public setMask(value: string, cursorPosition): { formatedValue; formatedCursorPosition } {
    if (value.length <= 3) {
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    } else if (value.length <= 6) {
      const formatedValue = value.replace(/^(\d{3})(\d{1,3})$/, '$1.$2');
      const formatedCursorPosition = cursorPosition < 3 ? cursorPosition : cursorPosition + 1;

      return { formatedValue, formatedCursorPosition: formatedCursorPosition };
    } else if (value.length <= 10) {
      const formatedValue = value.replace(/^(\d{3})(\d{3})(\d{1,4})/, '$1.$2.$3');

      let formatedCursorPosition = cursorPosition;
      if (cursorPosition >= 3) formatedCursorPosition++;
      if (cursorPosition >= 6) formatedCursorPosition++;

      return { formatedValue, formatedCursorPosition: formatedCursorPosition };
    } else {
      const formatedValue = value.replace(/(\d{3})(\d{3})(\d{1,4})(\d{1})/, '$1.$2.$3-$4');
      let formatedCursorPosition = cursorPosition;
      if (cursorPosition >= 3) formatedCursorPosition++;
      if (cursorPosition >= 6) formatedCursorPosition++;

      return { formatedValue, formatedCursorPosition: formatedCursorPosition };
    }
  }
  public validate(pis) {
    const multiplicadorBase = '3298765432';
    let total = 0;
    let resto = 0;
    let multiplicando = 0;
    let multiplicador = 0;
    let digito = 99;

    // Retira a mascara
    const numeroPIS = pis.replace(/[^\d]+/g, '');
    if (
      numeroPIS.length !== 11 ||
      numeroPIS === '00000000000' ||
      numeroPIS === '11111111111' ||
      numeroPIS === '22222222222' ||
      numeroPIS === '33333333333' ||
      numeroPIS === '44444444444' ||
      numeroPIS === '55555555555' ||
      numeroPIS === '66666666666' ||
      numeroPIS === '77777777777' ||
      numeroPIS === '88888888888' ||
      numeroPIS === '99999999999'
    ) {
      return false;
    } else {
      for (let i = 0; i < 10; i++) {
        multiplicando = parseInt(numeroPIS.substring(i, i + 1));
        multiplicador = parseInt(multiplicadorBase.substring(i, i + 1));
        total += multiplicando * multiplicador;
      }
      resto = 11 - (total % 11);
      resto = resto === 10 || resto === 11 ? 0 : resto;
      digito = parseInt('' + numeroPIS.charAt(10));
      return resto === digito;
    }
  }
  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['PIS_PASEP']];
  }
}
